import Grid from '@mui/material/Grid';
import { issueFields } from '@safc/configuration';
import { TitleField } from 'components/ui/form/FormLabel/TitleField.js';
import type { GenericFormField } from 'components/ui/form/GenericForm/GenericForm.types.js';
import type { Control } from 'react-hook-form';

export const IssueFormRow = ({
  field,
  control,
  children,
  isNumber = false,
}: {
  field: keyof typeof issueFields;
  control: Control<any>;
  /** It's not pure that `isNumber` is here, but it is super convenient */
  isNumber?: boolean;
  children: (props: { field: GenericFormField; control: Control }) => React.ReactNode;
}) => {
  const fieldData = issueFields[field];

  return (
    <Grid container mb={3} width="100%" data-testid="issue-form-row">
      <Grid size={{ xs: 5.5 }}>
        <TitleField
          title={fieldData.title}
          tooltip={fieldData.tootlipText}
          description={fieldData.description}
          required={fieldData.required}
        />
      </Grid>
      <Grid size={{ xs: 6.5 }}>
        {children({
          field: {
            name: field,
            placeholder: fieldData.placeholder,
            type: isNumber ? 'number' : 'text',
          },
          control,
        })}
      </Grid>
    </Grid>
  );
};
